"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.Column = exports.Container = exports.StyledChip = exports.getChipStyles = exports.StyledChipRightChild = exports.StyledChipLeftChild = exports.StyledChipChild = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
var types_1 = require("../../utils/types");
exports.StyledChipChild = styled_components_1.default.span({
    display: 'inline-flex',
    whiteSpace: 'nowrap'
});
exports.StyledChipLeftChild = styled_components_1.default.span({
    display: 'inline-flex'
});
exports.StyledChipRightChild = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  margin-left: 4px;\n  white-space: nowrap;\n"], ["\n  display: inline-flex;\n  margin-left: 4px;\n  white-space: nowrap;\n"])));
exports.getChipStyles = function (disabled, theme, isSelected) {
    var _a, _b;
    var lightActionStyles = disabled ? {} : {
        ':hover': {
            color: theme_1.colors.grey700,
            borderColor: theme_1.colors.grey700,
            backgroundColor: theme_1.colors.grey50,
            svg: {
                fill: theme_1.colors.grey700
            }
        },
        ':focus': {
            color: theme_1.colors.grey700,
            borderColor: theme_1.colors.grey700,
            backgroundColor: theme_1.colors.grey50,
            svg: {
                fill: theme_1.colors.grey700
            }
        },
        ':active': {
            color: theme_1.colors.grey700,
            borderColor: theme_1.colors.grey700,
            backgroundColor: theme_1.colors.grey200,
            svg: {
                fill: theme_1.colors.grey700
            }
        },
    };
    var lightSelectedActionStyles = disabled ? {} : {
        ':hover': {
            color: theme_1.colors.green700,
            borderColor: theme_1.colors.green700,
            backgroundColor: theme_1.colors.green100,
            svg: {
                fill: theme_1.colors.grey700
            }
        },
        ':focus': {
            color: theme_1.colors.green700,
            borderColor: theme_1.colors.green700,
            backgroundColor: theme_1.colors.green100,
            svg: {
                fill: theme_1.colors.grey700
            }
        },
        ':active': {
            color: theme_1.colors.green700,
            borderColor: theme_1.colors.green700,
            backgroundColor: theme_1.colors.green200,
            svg: {
                fill: theme_1.colors.grey700
            }
        },
    };
    var darkActionStyles = disabled ? {} : {
        ':hover': {
            color: theme_1.colors.white,
            borderColor: theme_1.colors.white,
            backgroundColor: theme_1.colors.grey600,
            svg: {
                fill: theme_1.colors.white
            }
        },
        ':focus': {
            color: theme_1.colors.white,
            borderColor: theme_1.colors.white,
            backgroundColor: theme_1.colors.grey600,
            svg: {
                fill: theme_1.colors.white
            }
        },
        ':active': {
            color: theme_1.colors.white,
            borderColor: theme_1.colors.white,
            backgroundColor: theme_1.colors.grey500,
            svg: {
                fill: theme_1.colors.white
            }
        },
    };
    var darkSelectedActionStyles = disabled ? {} : {
        ':hover': {
            color: theme_1.colors.green200,
            borderColor: theme_1.colors.green200,
            backgroundColor: theme_1.colors.green800,
            svg: {
                fill: theme_1.colors.green200
            }
        },
        ':focus': {
            color: theme_1.colors.green200,
            borderColor: theme_1.colors.green200,
            backgroundColor: theme_1.colors.green800,
            svg: {
                fill: theme_1.colors.green200
            }
        },
        ':active': {
            color: theme_1.colors.green200,
            borderColor: theme_1.colors.green200,
            backgroundColor: theme_1.colors.green700,
            svg: {
                fill: theme_1.colors.green200
            }
        },
    };
    var chipSelectedStyles = (_a = {},
        _a[types_1.LIGHT] = __assign({ color: disabled ? theme_1.colors.grey400 : theme_1.colors.green600, backgroundColor: theme_1.colors.green50, border: '2px solid', borderColor: disabled ? theme_1.colors.grey200 : theme_1.colors.green600, svg: {
                fill: disabled ? theme_1.colors.grey400 : theme_1.colors.green600,
            } }, lightSelectedActionStyles),
        _a[types_1.DARK] = __assign({ color: disabled ? theme_1.colors.grey400 : theme_1.colors.green300, backgroundColor: theme_1.colors.transparent, border: '2px solid', borderColor: disabled ? theme_1.colors.grey200 : theme_1.colors.green300, svg: {
                fill: disabled ? theme_1.colors.grey400 : theme_1.colors.green300,
            } }, darkSelectedActionStyles),
        _a);
    var chipStyles = (_b = {},
        _b[types_1.LIGHT] = __assign({ color: disabled ? theme_1.colors.grey400 : theme_1.colors.grey500, border: '1px solid', borderColor: disabled ? theme_1.colors.grey200 : theme_1.colors.grey300, svg: {
                fill: disabled ? theme_1.colors.grey400 : theme_1.colors.grey500,
            } }, lightActionStyles),
        _b[types_1.DARK] = __assign({ color: disabled ? theme_1.colors.grey400 : theme_1.colors.grey300, border: '1px solid', background: disabled ? theme_1.colors.white : 'transparent', borderColor: disabled ? theme_1.colors.grey200 : theme_1.colors.grey500, svg: {
                fill: disabled ? theme_1.colors.grey400 : theme_1.colors.grey300,
            } }, darkActionStyles),
        _b);
    var selectedStyles = isSelected ? chipSelectedStyles[theme] : {};
    return __assign(__assign({}, chipStyles[theme]), selectedStyles);
};
exports.StyledChip = styled_components_1.default.div({
    padding: '0 16px',
    alignItems: 'center',
    border: 'none',
    display: 'inline-flex',
    height: '40px',
    justifyContent: 'space-between',
    lineHeight: '20px',
    minWidth: '32px',
    outline: 'none',
    position: 'relative',
    textAlign: 'center',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '32px',
    boxSizing: 'border-box',
    fontSize: '16px',
    cursor: 'pointer',
    marginRight: '8px'
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme, selected = _a.selected;
    return (__assign({}, exports.getChipStyles(disabled, theme, selected)));
}, function (_a) {
    var small = _a.small;
    return (small ? {
        height: '32px',
        fontSize: '13px',
        lineHeight: '16px',
        padding: '0 12px'
    } : {});
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? {
        cursor: 'not-allowed'
    } : {});
});
exports.Container = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 16px 80px;\n    display: flex;\n    flexDirection: column;\n"], ["\n    margin: 16px 80px;\n    display: flex;\n    flexDirection: column;\n"])));
exports.Column = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    margin: 24px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    margin: 24px;\n"])));
exports.Title = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: 12px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid ", ";\n    white-space: nowrap;\n"], ["\n    margin-bottom: 12px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid ", ";\n    white-space: nowrap;\n"])), theme_1.colors.grey4);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map